export const BUSINESS = {
  name: "Repair Tec Pro",
  phone: "619-856-3309",
  phoneHref: "tel:+16198563309",
  email: "nevanfitzpatrick@gmail.com",
  emailHref: "mailto:nevanfitzpatrick@gmail.com",
  serviceArea: "Southern Oregon",
  tagline: "Commercial repair specialists for HVAC, refrigeration, and cooking equipment.",
  established: "Family-operated · Southern Oregon based",
  basePrice: "$65",
  basePriceLabel: "service call",
  consultLabel: "Free phone & video consultation",
};

export const SERVICES = [
  {
    id: "hvac",
    label: "01",
    title: "HVAC Repair",
    short: "Heating & cooling systems for businesses and homes.",
    description:
      "Diagnostics, refrigerant work, compressor replacements, condenser and evaporator repair, thermostat & control upgrades, preventive maintenance and emergency service for split systems, packaged units, mini-splits and rooftop units.",
    bullets: [
      "Split & packaged units",
      "Mini-split / ductless systems",
      "Rooftop units (RTUs)",
      "Refrigerant leak repair",
      "Compressor & motor replacement",
    ],
    image:
      "https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "refrigeration",
    label: "02",
    title: "Commercial Refrigeration",
    short: "Walk-ins, reach-ins, prep tables, ice machines.",
    description:
      "Full commercial refrigeration service: walk-in coolers and freezers, reach-in units, prep tables, display cases, ice machines, and beverage coolers. We restore temperature, fix leaks and rebuild systems to keep product safe and compliant.",
    bullets: [
      "Walk-in coolers & freezers",
      "Reach-in & prep tables",
      "Ice machines & beverage coolers",
      "Display & deli cases",
      "Refrigerant recovery & recharge",
    ],
    image:
      "https://images.unsplash.com/photo-1777372327900-1e117bbe3a7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwcmVmcmlnZXJhdGlvbiUyMGNvb2xlcnxlbnwwfHx8fDE3Nzc4NDMwMjR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "cooking",
    label: "03",
    title: "Cooking Equipment",
    short: "Ranges, ovens, fryers, grills, steamers.",
    description:
      "Repair and tune-ups for commercial cooking lines: gas and electric ranges, convection and combi ovens, fryers, char-broilers, griddles, steamers and salamanders. We diagnose ignition, gas valves, thermostats, elements and controls.",
    bullets: [
      "Gas & electric ranges",
      "Convection & combi ovens",
      "Fryers & char-broilers",
      "Griddles & steamers",
      "Ignition, valves & controls",
    ],
    image:
      "https://images.unsplash.com/photo-1771360963016-1408c2de12c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwa2l0Y2hlbiUyMHJlc3RhdXJhbnQlMjBzdG92ZXxlbnwwfHx8fDE3Nzc4NDMwMjR8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGE =
  "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";
